import React from "react";
import LegalLayout from "../../components/LegalLayout";

const GizlilikPolitikasi = () => {
  return (
    <LegalLayout title="Gizlilik Politikası">

      <h2>1. Amaç</h2>

      <p>
        One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ. olarak müşterilerimizin ve
        ziyaretçilerimizin kişisel verilerinin gizliliğine önem veriyoruz.
        Web sitemizi kullanmanız sırasında paylaştığınız bilgiler,
        6698 Sayılı Kişisel Verilerin Korunması Kanunu (KVKK) başta olmak üzere
        ilgili mevzuata uygun olarak işlenmekte ve korunmaktadır.
      </p>

      <br />

      <h2>2. Toplanan Bilgiler</h2>

      <p>
        Sipariş oluşturulması ve hizmet sunulabilmesi amacıyla aşağıdaki bilgiler
        toplanabilir:
      </p>

      <ul>
        <li>Ad ve Soyad</li>
        <li>Telefon Numarası</li>
        <li>E-posta Adresi</li>
        <li>Teslimat ve Fatura Adresi</li>
        <li>Sipariş Bilgileri</li>
        <li>IP Adresi ve Teknik Kayıtlar</li>
      </ul>

      <br />

      <h2>3. Bilgilerin Kullanım Amaçları</h2>

      <p>Toplanan bilgiler aşağıdaki amaçlarla kullanılmaktadır:</p>

      <ul>
        <li>Siparişlerin alınması ve hazırlanması</li>
        <li>Ürünlerin teslim edilmesi</li>
        <li>Müşteri destek hizmetlerinin sunulması</li>
        <li>İade ve değişim işlemlerinin yürütülmesi</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        <li>Dolandırıcılığın önlenmesi ve güvenliğin sağlanması</li>
      </ul>

      <br />

      <h2>4. Ödeme Güvenliği</h2>

      <p>
        Web sitemizde gerçekleştirilen ödemeler SSL ile korunan güvenli ödeme
        altyapısı üzerinden gerçekleştirilmektedir.
      </p>

      <p>
        Kredi kartı bilgileriniz hiçbir şekilde One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ. sistemlerinde saklanmaz. Kart bilgileriniz yalnızca ödeme kuruluşu
        tarafından işlenmektedir.
      </p>

      <br />

      <h2>5. Çerez (Cookie) Kullanımı</h2>

      <p>
        Web sitemiz kullanıcı deneyimini geliştirmek, güvenliği sağlamak ve
        sitenin daha verimli çalışmasını sağlamak amacıyla çerezlerden
        yararlanabilir.
      </p>

      <p>
        Tarayıcı ayarlarınız üzerinden çerez kullanımını dilediğiniz zaman
        değiştirebilir veya devre dışı bırakabilirsiniz.
      </p>

      <br />

      <h2>6. Bilgilerin Paylaşılması</h2>

      <p>
        Kişisel verileriniz;
      </p>

      <ul>
        <li>Yasal zorunluluklar dışında üçüncü kişilerle paylaşılmaz.</li>
        <li>Ödeme kuruluşları ile ödeme işlemlerinin tamamlanması amacıyla paylaşılabilir.</li>
        <li>Kargo firmaları ile teslimatın gerçekleştirilebilmesi amacıyla paylaşılabilir.</li>
        <li>Yetkili kamu kurum ve kuruluşlarının talebi halinde ilgili mevzuat kapsamında paylaşılabilir.</li>
      </ul>

      <br />

      <h2>7. Veri Güvenliği</h2>

      <p>
        One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ., kişisel verilerin güvenliğini
        sağlamak amacıyla gerekli teknik ve idari tedbirleri almaktadır.
      </p>

      <br />

      <h2>8. Haklarınız</h2>

      <p>
        KVKK kapsamında kişisel verileriniz hakkında bilgi talep edebilir,
        düzeltilmesini, silinmesini veya işlenmesine ilişkin taleplerinizi
        tarafımıza iletebilirsiniz.
      </p>

      <br />

      <h2>9. İletişim</h2>

      <p>
        Gizlilik Politikası hakkında her türlü soru ve talepleriniz için bizimle
        aşağıdaki iletişim bilgilerinden irtibata geçebilirsiniz.
      </p>

      <ul>
        <li><strong>Şirket:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.</li>
        <li><strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9 Güngören / İstanbul</li>
        <li><strong>Telefon:</strong> 0537 210 14 52</li>
        <li><strong>E-posta:</strong> goomoreinternational@gmail.com</li>
      </ul>

    </LegalLayout>
  );
};

export default GizlilikPolitikasi;